module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/photo_1@2x-89a9c15af910ef009bf632f9cf4e9d6c.jpg";